import React from 'react';

const styles = {
  page: {
    textAlign: "left",
    border: '1px solid black',
    padding: '20px',
    marginBottom: '20px',
    backgroundColor: '#f9f9f9',
  },
  h1: {
    textAlign: 'center',
    paddingBottom: '10px',
    marginBottom: '20px',
  },
  h2: {
    marginTop: '30px',
  },
  h3: {
    marginTop: '20px',
    marginBottom: '10px',
  },
  ul: {
    paddingLeft: '20px',
    listStyleType: 'none',
  },
  li: {
    marginBottom: '5px',
  },
  section: {
    marginBottom: '20px',
  },
  subSection: {
    padding: "0 1.3rem"
  },
};

const PageShisetsuKijun = () => {
  const facilityStandards = [
    "外来感染対策向上加算",
    "外来データ提出加算",
    "ニコチン依存症管理料",
    "がん治療連携指導料",
    "在宅療養支援診療所/在宅時医学総合管理料",
    "在宅がん医療総合診療料",
  ];

  const additionalChargesDetails = [
    {
      title: "夜間・早朝等加算",
      description: "土曜日12時以降に受付をされた場合、厚生労働省の定めた診療報酬点数に基づき、夜間・早朝等加算として５０点を診察料に加算させていただきます。",
    },
    {
      title: "明細書発行体制等加算（詳細は院内掲示をご確認ください。）",
      description: "当院では診療報酬の算定項目が分かる明細書を無料で発行しています。",
    },
    {
      title: "医療情報取得加算",
      description: "当院は、マイナ保険証の利用を通じて患者様の診療情報を取得・活用することにより、質の高い医療の提供に努めています。",
    },
    {
      title: "一般名処方加算（詳細は院内掲示をご確認ください。）",
      description: ["当院では後発医薬品の使用促進を図るとともに、医薬品の安定供給に向けた取り組みなどを実施しています。", "後発医薬品のある医薬品について、特定の医薬品名を指定するのではなく、薬剤の成分を基にした一般名処方（一般的な名称により処方箋を発行すること）を行う場合があります。"],
    },
    {
      title: "外来感染対策向上加算（詳細は院内掲示をご確認ください。）",
      description: "当院は都道府県知事の指定を受けている第二種協定指定医療機関または医療措置協定に基づく措置を講ずる医療機関です。当院では受診歴の有無に関わらず、発熱およびその他の感染症を疑わせるような症状を呈する患者様の受入れを行っています。",
    },
    {
      title: "生活習慣病管理料Ⅰ・Ⅱ",
      description: ["生活習慣病（高血圧症、脂質異常症、糖尿病）に関して、療養指導に同意した方が対象となります。", "患者様の状態に応じ、医師の判断のもと、リフィル処方や28日以上の長期の投薬を行う場合がございます。"],
    },
    {
      title: "外来データ提出加算",
      description: "医療の質の向上、医療費抑制を目的とし、診療報酬の請求状況などの診療内容についてのデータを継続して厚労省に提出しております",
    },
    {
      title: "ニコチン依存症管理料",
      description: ["当院はニコチン依存症管理料の届出を行っており、禁煙のための治療的サポートをする禁煙外来を行っています。", "院内とその周辺は全面禁煙ですのでご理解・ご協力をお願いいたします。"],
    },
    {
      title: "がん治療連携指導料",
      description: "計画策定病院と連携をとりながら治療を行います。",
    },
    {
      title: "在宅療養支援診療所・在宅時医学総合管理料",
      description:["在宅で療養する患者さんを対象に、緊急時の連絡体制及び24時間往診・訪問看護ができる体制等を確保しています。", "「第9」の1の1の（3）に算定する在宅支援診療所の点数を算定します。"],
    },
    {
      title: "在宅がん医療総合診療料",
      description: "当院では、通院が困難な末期の悪性腫瘍の患者さんに対して総合的な在宅医療計画を策定し、訪問診療または訪問看護を合わせて週4日以上(訪問診療及び訪問看護をそれぞれ週1回以上)行った場合に、1週間を単位として在宅がん医療総合診療料を算定いたします。",
    },
  ];

  const renderDescription = (descriptions) => {
    if (Array.isArray(descriptions)) {
      return descriptions.map((line, index) => (
        <React.Fragment key={index}>
          {line}
          {index < descriptions.length - 1 && <br />} 
        </React.Fragment>
      ));
    }
    return descriptions;
  }

  return (
    <div style={styles.page}>
      <h1 style={styles.h1}>当院のご案内</h1> 
      <div style={styles.section}>
        <h3>■　医師・開設者・管理者：院長 久木田　雅弘（くきた　まさひろ）</h3> 
        <h3 style={styles.h3}>■　許可指定事項</h3>
        <ul style={styles.ul}>
          <li className="listTriangle">保険医療機関</li> 
          <li className="listTriangle">被爆者一般疾病医療機関</li> 
          <li className="listTriangle">難病医療費助成指定医療機関</li> 
          <li className="listTriangle">医療措置協定締結医療機関（第二種協定指定医療機関）</li> 
        </ul>
      </div>

      <div style={styles.section}>
        <h2 style={styles.h2}>当院では以下の施設基準を届け出ています。</h2>
        <ul style={styles.ul}>
          {facilityStandards.map((standard, index) => (
            <li className="listTriangle" key={index}>{standard}</li>
          ))}
        </ul>
      </div>

      <div style={styles.section}>
        <h2 style={{...styles.h2, marginBottom: "0"}}>当院の施設基準または加算について</h2>
        <div style={styles.subSection}>
          {additionalChargesDetails.map((item, index) => (
            <div key={index} style={{ marginBottom: '15px' }}>
              <h3 style={styles.h3}>{item.title}</h3>
              <p style={{padding: "0 1rem", marginTop: "0"}}>{renderDescription(item.description)}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};


// Appコンポーネント (施設基準のページのみを表示)
const Criterion = () => {
  return (
    <div className="main-wrapper" id="main-wrapper" style={styles.container}>
      <div className="content-container">
        <PageShisetsuKijun />
      </div>
    </div>
  );
};

export default Criterion;
